import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import ReactPlayer from 'react-player';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TypoFramed from '../../components/TypoFramed';
import PopupPage from '../../components/PopupPage';
import { ReactComponent as Play } from '../../res/play.svg';
import styles from './styles';

class PopupArticle extends React.Component {
  render() {
    const { data, classes, open, onClose, baseUrl } = this.props;
    const preview = `${baseUrl}/interviews/${data.popup.article.preview}`;
    const { videoUrl } = data.popup.article;
    return (
      <PopupPage open={open} onClose={onClose}>
        <div className={classes.container}>
          <div className={classes.textContent}>
            <Typography variant="h3" className={classes.title}>
              {parse(data.popup.article.title)}
            </Typography>
            <TypoFramed frame="black" space={false} className={classes.subtitle}>
              {parse(data.popup.article.subtitle)}
            </TypoFramed>
            <Typography variant="body1" className={classes.desc}>
              {parse(data.popup.article.desc)}
            </Typography>
          </div>
          <div className={classes.playerWrapper}>
            <ReactPlayer
              light={preview}
              url={videoUrl}
              playIcon={<Play className={classes.playIcon} />}
              width="100%"
              height="100%"
              playing
              controls
              className={classes.player}
            />
          </div>
        </div>
      </PopupPage>
    );
  }
}

PopupArticle.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  baseUrl: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default withStyles(styles)(PopupArticle);
